import { Heart } from "lucide-react";
import { cn } from "@/lib/utils";

/**
 * The single definition of the "Made with (heart) by remote workers" aside.
 * Every footer and page template renders this component so the wording,
 * size and heart colour can never drift apart.
 */
export function MadeByRemoteWorkers({ className }: { className?: string }) {
  return (
    <p className={cn("text-sm text-muted-foreground flex items-center gap-1.5", className)}>
      Made with <Heart className="h-4 w-4 text-cinnamon fill-cinnamon" /> by remote workers
    </p>
  );
}
